export default __webpack_public_path__ + "static/crystal-9d7d766cdb00a0d2aa80a79de4453e8d.gif";